import { render, staticRenderFns } from "./Rte.vue?vue&type=template&id=5c5908e8&"
import script from "./Rte.vue?vue&type=script&lang=js&"
export * from "./Rte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports